const views = {};
/**
 * Customer Row
 */
views.customer_row = Backbone.View.extend({
  template: require("./templates/customer_row.hbs"),
  data: false,
  selector: false,
  initialize: function (data) {
    this.data = data;
    if (data.selector) {
      this.data.selector = data.selector;
    } else {
      this.data.selector = false;
    }
    this.data.selected = false;
    this.callback = false;
  },
  selected: function () {
    this.selected = true;
    this.data.selected = true;
  },
  render: function (data) {
    this.$el.html(this.template(this.data));
    $("#customer_results tbody").append(this.$el);
  },
  events: {
    "click .radio-col input": "storeThis",
    "click .customer_select": "storeThis",
  },
  storeThis: function (e) {
    $.publish("customer-select-change", $(e.currentTarget).val());
    if (!P3Portal.recentCustomers) P3Portal.recentCustomers = {};
    P3Portal.recentCustomers[this.data.index] = this.data;
    window.localStorage.setItem(
      "p3.recentCustomers",
      JSON.stringify(P3Portal.recentCustomers)
    );
    if (this.callback) {
      this.callback(this.data.index);
    }
  },
  checkRow: function () {
    $(".radio-col input", this.$el).attr("checked", true);
  },
  clicked: function (callback) {
    this.callback = callback;
  },
});

/**
 * Supplier Row
 */
views.supplier_row = Backbone.View.extend({
  template: require("./templates/supplier_row.hbs"),
  data: false,
  select: false,
  initialize: function (data) {
    this.data = data;
    this.data.selected = false;
    this.callback = false;
  },
  selected: function () {
    this.selected = true;
    this.data.selected = true;
  },
  render: function (data) {
    this.$el.html(this.template(this.data));
    $("#supplier_results tbody").append(this.$el);
  },
  events: {
    "click .supplier_select": "storeThis",
  },
  storeThis: function (e) {
    $.publish("supplier-select-change", $(e.currentTarget).val());
    if (!P3Portal.recentSuppliers) P3Portal.recentSuppliers = {};
    P3Portal.recentSuppliers[this.data.index] = this.data;
    window.localStorage.setItem(
      "p3.recentSuppliers",
      JSON.stringify(P3Portal.recentSuppliers)
    );

    if (this.callback) {
      this.callback(this.data.index);
    }
  },
  checkRow: function () {
    $(".radio-col input", this.$el).attr("checked", true);
  },
  clicked: function (callback) {
    this.callback = callback;
  },
});

/***
 * Build the file upload visible row
 */
views.fileupload_row = Backbone.View.extend({
  template: require("./templates/fileupload_row.hbs"),
  data: false,
  onRemove: false,
  initialize: function (data) {
    this.data = data;
    if (data.onRemove) this.onRemove = data.onRemove;
  },
  render: function (data) {
    this.$el.html(this.template(this.data));
    $(this.data.$parent).append(this.$el);
  },
  events: {
    "click .remove-file": "removeRow",
  },
  removeRow: function () {
    console.log("removing");
    $("#" + this.data.id).remove();
    this.remove();
    this.onRemove();
  },
});

exports.views = views;
